import { graphql } from 'react-relay';

/**
 * Added item to initial query to be able to pull
 * handlePdpStatuses_item on server to determine if we need to redirect or 404.
 * Do not add other framments to item in this query
 */

export const pdpRespRootQuery = graphql`
    query pdpRespRootQuery(
        $isClient: Boolean!
        $itemId: String!
        $itemIds: [String]!
        $userId: String = ""
        $userIds: [String]
        $fetchUser: Boolean!
        $relationshipUserIds: [String]!
        $followSearchPages: [String]
        $fetchFollowSearch: Boolean!
        $isTrade: Boolean!
        $isMultiSku: Boolean!
        $fetchPdp: Boolean!
        $forcedCurrency: Currency
        $fetchRegionalInfo: Boolean = false
        $userZipCode: String!
        $userCountryCode: String
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
        $isPdpDealerChatTest: Boolean = false
    ) {
        viewer {
            ...PdpRespLayout_viewer
            ...getLanguageAnnotationsAndDomainLinksPdp_viewer
            ... on Viewer {
                ...handlePdpStatuses_viewer
            }
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    ...handlePdpStatuses_item
                }
                ...findPdpItemReadError_itemRead
            }
        }
    }
`;

export const pdpRespVariables = {
    isClient: false,
    itemId: null,
    itemIds: [],
    newAndCustomSplitTest: false,
    selectedItemIds: [],
    userId: '',
    userIds: [],
    fetchUser: false,
    loadPortfolioData: false,
    relationshipUserIds: [],
    followSearchPages: null,
    fetchFollowSearch: false,
    isTrade: false,
    isMultiSku: false,
    fetchPdp: true,
    forcedCurrency: null,
    isPdpDealerChatTest: false,
};
